module.exports = __webpack_public_path__ + "media/images/sign-in-bg-2aaf7149e6a21cd73c61a46cd026ce00.jpg";